import React from 'react';

import styles from './Media.css';

const ListImage = props => {
  const { images, handleDelete, handleUpload, fields, itemDetail } = props;
  const isMaxImage = images.length >= 12;
  return (
    <div className={styles['image-wrapper']}>
      {fields.map((_, idx) => {
        const image = fields.get(idx);
        const imageItemDetail = !image.small_image_url
          ? image.raw_image_url
          : image.small_image_url;
        if (idx === 0) {
          return (
            <div key={idx} className={styles['main-image']}>
              <img
                className={styles['item-image']}
                src={
                  image.raw_image_url === ''
                    ? require('assets/images/loading-simple.gif')
                    : itemDetail && itemDetail.id
                    ? imageItemDetail
                    : image.raw_image_url
                }
              />
              <div className={styles['main-image-badge']}>
                <span>Main Image</span>
              </div>
              <div className={styles['delete-button']}>
                <button
                  type="button"
                  onClick={() => handleDelete(idx)}
                  className={styles['close-icon']}
                />
              </div>
            </div>
          );
        }
        return (
          <div key={idx} className={styles['item-image-container']}>
            <img
              className={styles['item-image']}
              src={
                image.raw_image_url === ''
                  ? require('assets/images/loading-simple.gif')
                  : itemDetail && itemDetail.id
                  ? imageItemDetail
                  : image.raw_image_url
              }
            />
            <div className={styles['delete-button-item']}>
              <button
                type="button"
                onClick={() => handleDelete(idx)}
                className={styles['close-icon']}
              />
            </div>
          </div>
        );
      })}
      {!isMaxImage && (
        <div className={styles['mini-box-upload-container']}>
          <label className={styles['mini-box-button-upload']}>
            Upload File
            <input
              accept=".jpg, .jpeg, .png, .bmp"
              type="file"
              onChange={handleUpload}
            />
          </label>
        </div>
      )}
    </div>
  );
};

export default ListImage;
